import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-VI',
    templateUrl: './rs005-card-VI.component.html'
})

export class Rs005CardVIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Ear Sorter', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Total_espigas_avaliadas_retorno: [null, [this.totalEspigasRetornoValidator()]],
                Num_espigas_despalhadas_retorno: [null, []],
                Total_espigas_avaliadas_mesa: [null, [this.totalEspigasMesaValidator()]],
                Num_espigas_palha_mesa: [null, []],
                Espigas_despalhadas_retorno: [null, []],
                Espigas_palha_mesa: [null, []],
            });
        }
        else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                selecao_horas: [null, [Validators.required]],
                debulhas_horas: [null, [Validators.required]],
                tempo_atraso_secagem: [null, [Validators.required]],
                tempo_atraso_selecao: [null, [Validators.required]],
                tempo_parada_selecao: [null, [Validators.required]],
                tempo_parada_debulha: [null, [Validators.required]],
            });
            this.step = 'Tempos de atividades'
        }

    }

    async ngOnInit(): Promise<void> {
        this.formulario?.get('Num_espigas_palha_mesa')?.valueChanges.subscribe(() => {
            this.formulario?.get('Total_espigas_avaliadas_mesa')?.updateValueAndValidity();
        });

        this.formulario?.get('Num_espigas_despalhadas_retorno')?.valueChanges.subscribe(() => {
            this.formulario?.get('Total_espigas_avaliadas_retorno')?.updateValueAndValidity();
        });
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    totalEspigasMesaValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const totalEspigasMesa = control.value;
            const numEspigasPalhaMesa = control.parent?.get("Num_espigas_palha_mesa")?.value;

            if (totalEspigasMesa < numEspigasPalhaMesa) {
                return { invalidQuantidadeEspigasMesa: true };
            }
            return null;
        };

    }
    totalEspigasRetornoValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const totalEspigasRetorno = control.value;
            const numEspigasPalhaRetorno = control.parent?.get("Num_espigas_despalhadas_retorno")?.value;

            if (totalEspigasRetorno < numEspigasPalhaRetorno) {
                return { invalidQuantidadeEspigasRetorno: true };
            }
            return null;
        };
    }

}